import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ComplianceSuccessIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M5.28 7.165a.8.8 0 0 1 1.132 0L7.59 8.344 9.783 5.42a.8.8 0 1 1 1.28.96l-2.746 3.662a.8.8 0 0 1-1.206.086l-1.83-1.831a.8.8 0 0 1 0-1.132M2.664 3.098l4.86-1.86c.306-.118.646-.118.953 0l4.859 1.86c.516.197.856.693.856 1.245v3.298a6.67 6.67 0 0 1-3.35 5.783l-2.179 1.25c-.41.236-.916.236-1.326 0l-2.18-1.25a6.67 6.67 0 0 1-3.35-5.783V4.343c0-.552.341-1.048.857-1.245m.744 1.428v3.115c0 1.815.97 3.492 2.545 4.395L8 13.21l2.046-1.174a5.07 5.07 0 0 0 2.546-4.395V4.526L8 2.768z"
      clipRule="evenodd"
    />
  </svg>
);
ComplianceSuccessIcon.id = 'ComplianceSuccessIcon';
ComplianceSuccessIcon.displayName = 'ComplianceSuccessIcon';
export default ComplianceSuccessIcon;
